import React from 'react';

import { Result } from 'models/Search';
import ResultImage from './ResultImage';
import { dispatchRocEvent } from 'shared/hooks/useRocEventHandler';
import { WithTestIdOptional } from 'shared-client/types/test';

export interface ResultItemProps extends WithTestIdOptional {
	item: Result;
}

function ResultItem({ item }: ResultItemProps) {
	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');
	// #region Commerce
	const uniqueId = item.getDocumentValue('uniqueId');
	// #endregion

	return (
		<div className="hawk-results__item">
			<ResultImage item={item} />

			<div className="hawk-results__item-name">
				{url ? (
					<a
						className="hawk-results__item-name-link"
						href={url}
						// #region Commerce
						onClick={() => {
							if (uniqueId) {
								dispatchRocEvent('product-clicked', {
									productId: uniqueId,
									url: url,
									productName: itemName ?? '',
									productGroupId: null,
								});
							}
						}}
						// #endregion
					>
						<span>{itemName}</span>
					</a>
				) : (
					<span>{itemName}</span>
				)}
			</div>
		</div>
	);
}

export default ResultItem;
